import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

export interface LoaderContent {
    isDynamic?: boolean;
    topTitle?: string;
    topDescription?: string;
    bottomTitle?: string;
    bottomDescription?: string;
}

@Injectable({ providedIn: "root" })
export class LoaderService {
    private loader$ = new BehaviorSubject<Boolean>(false);
    public loader = this.loader$.asObservable();

    private content$ = new BehaviorSubject<LoaderContent | null>(null);
    public content = this.content$.asObservable();

    constructor() { }
    show(content?: LoaderContent) {
        // CASE 1: Nothing passed → default loader
        if (!content) {
            this.content$.next({ isDynamic: false });
            this.loader$.next(true);
            return;
        }

        // CASE 2: If any key exists, activate dynamic mode
        const hasDynamicKeys =
            content.topTitle ||
            content.topDescription ||
            content.bottomTitle ||
            content.bottomDescription;

        content.isDynamic = !!hasDynamicKeys;

        this.content$.next(content);
        this.loader$.next(true);
    }



    hide() {
        this.content$.next(null);
        this.loader$.next(false);
    }
}
